import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const AccountApi = {
    isVerified: (options?: BaseApiQueryOptions) => apiQueryOptions(['account', 'isVerified'], (api) => api.account.isVerified(), options),
    get: (options?: BaseApiQueryOptions) => apiQueryOptions(['account', 'get'], (api) => api.account.get(), options),

    verify: (options?: BaseApiMutationOptions<ApiClient['account']['verify']>) => apiMutationOptions((api) => api.account.verify, options),
    resendVerificationEmail: (options?: BaseApiMutationOptions<ApiClient['account']['resendVerificationEmail']>) =>
        apiMutationOptions((api) => api.account.resendVerificationEmail, options),
    updateProfile: (options?: BaseApiMutationOptions<ApiClient['account']['updateProfile']>) => apiMutationOptions((api) => api.account.updateProfile, options),
    updateProfileImageAltText: (options?: BaseApiMutationOptions<ApiClient['account']['updateProfileImageAltText']>) =>
        apiMutationOptions((api) => api.account.updateProfileImageAltText, options),
    deleteProfileImage: (options?: BaseApiMutationOptions<ApiClient['account']['deleteProfileImage']>) =>
        apiMutationOptions((api) => api.account.deleteProfileImage, options),
    deleteBannerImage: (options?: BaseApiMutationOptions<ApiClient['account']['deleteBannerImage']>) =>
        apiMutationOptions((api) => api.account.deleteBannerImage, options),
    deleteAccount: (options?: BaseApiMutationOptions<ApiClient['account']['deleteAccount']>) => apiMutationOptions((api) => api.account.deleteAccount, options)
};
